import './Story.scss';
import Meals from '../widgets/Meals';
import Video from '../Video/Video';
import Quote from '../widgets/Quote';
import Money from '../widgets/Money';
import Housing from '../widgets/Housing';

/**
 * titles
 * location
 * subtitle
 * text
 * image
 */

function Story(props) {
  return (
    <div className="story">
      <div className="h-line"></div>
      <p className="story__tag">{props.story.tag}</p>
      <p className="story__title trajan">{props.story.title}</p>
      <p className="story__location">{props.story.location}</p>

      <div className="story__splits">
        <div>
          <p className="story__sub-title">{props.story.subTitle}</p>
          <p className="story__text">{props.story.text}</p>
        </div>
        <div>
          {props.index === 0 && <Meals />}
          {props.index === 1 && (
            <div>
              <Quote />
            </div>
          )}
          {props.index === 2 && (
            <div>
              <Money />
            </div>
          )}
          {props.index === 3 && (
            <div>
              <Housing />
            </div>
          )}
        </div>
      </div>
      {props.index === 0 && (
        <div className="story__video-container">
          <Video url={'https://player.vimeo.com/video/647921605?h=cf371114c0'} />
        </div>
      )}
      {props.index === 1 && (
        <div className="story__video-container">
          <Video url={'https://player.vimeo.com/video/656185060?h=db89952d25'} />
        </div>
      )}
      {props.index === 2 && (
        <div className="story__video-container">
          <Video url={'https://player.vimeo.com/video/656234662?h=40a5c3d813'} />
        </div>
      )}
    </div>
  );
}
export default Story;
